import { api } from './client';

export interface UserProfile {
  id: string;
  username: string | null;
  full_name: string | null;
  avatar_url: string | null;
  role: 'admin' | 'employee';
}

export const profileApi = {
  get: () => api.get<{ profile: UserProfile }>('/profile'),
  updateNickname: (nickname: string) => api.patch<{ profile: UserProfile }>('/profile', { nickname }),
  uploadAvatar: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.postFormData<{ avatarUrl: string }>('/profile/avatar', form);
  },
};
